import React, {useState} from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import '../Pacientes/Pacientes.css'
import './Cuidadores.css'
import { ContentBodyCuidadores } from '../../components/Cuidadores/ContentBodyCuidadores'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const Cuidadores = () => {

    const [MenuLateralAux, setMenuLateralAux] = useState();


    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='Usuarios' >
                <div className='headerUsuarios'>
                    <HeaderHome 
                        chageMenuLateralAux={chageMenuLateralAux} 
                    />
                </div>
                <div className="bodyUsuarios">
                    <ContentBodyCuidadores
                        MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux} 
                    />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
